import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import calculatorReducer from "../calculator/slices/calculatorSlice";
import appReducer from "./slices/appSlice";
import { devLoggerMiddleware, loggerMiddleware } from "./loggerMiddleware";
import { isDevelopmentOrMockMode } from "../utils/utils";

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const store = configureStore({
  reducer: {
    app: appReducer,
    calculator: calculatorReducer,
  },
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware();
    if (isDevelopmentOrMockMode()) {
      middlewares.push(devLoggerMiddleware);
    } else {
      middlewares.push(loggerMiddleware);
    }
    return middlewares;
  },
});
